import React from "react";
import AppModal from "../common/AppModal";
import UpdateDocumentHeaderForm from "../../forms/UpdateDocumentHeaderForm";
import { DocumentHeaderResponseDto } from "../../shared/dtos/document/DocumentHeaderResponseDto";

interface UpdateDocumentHeaderModalProps {
  open: boolean;
  onClose: () => void;
  documentHeader: DocumentHeaderResponseDto | null;
  loading: boolean;
  error: string | null;
}

const UpdateDocumentHeaderModal: React.FC<UpdateDocumentHeaderModalProps> = ({
  open,
  onClose,
  documentHeader,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`Edit ${documentHeader?.documentType} Template`}
      width="md"
      loading={loading}
    >
      {documentHeader && (
        <UpdateDocumentHeaderForm
          documentHeader={documentHeader}
          loading={loading}
          error={error}
        />
      )}
    </AppModal>
  );
};

export default UpdateDocumentHeaderModal;
